export const onClientEntry = async () => {
  // Smooth scrolling enabled for all anchor links pointing to #ids
  require("smooth-scroll")('a[href*="#"]', {
    header: "#fixed-header",
    topOnEmptyHash: true,
    clip: true
  })

  require("jspolyfill-array.prototype.findIndex")

  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    await import(`intersection-observer`)
    console.log(`# IntersectionObserver is polyfilled!`)
  }

  // Object-fit/Object-position polyfill for gatsby-image (IE)
  const testImg = document.createElement(`img`)
  if (
    typeof testImg.style.objectFit === `undefined` ||
    typeof testImg.style.objectPosition === `undefined`
  ) {
    const objectFitImages = await import("object-fit-images")
    objectFitImages.default()
  }
}

export const shouldUpdateScroll = () => {
  window.scrollTo(0, 0)
  return false
}
